import isIterable from '../isIterable';
import { register } from './factory';
import Item from './transcript/Item';
import Type from './Type';
export class Transcript {
    constructor(init) {
        this.type = Type.Transcript;
        const {items} = isIterable(init) ? { items: init } : init;
        this.items = Array.from(items, i => new Item(i));
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.items.configurable = false;
        descriptors.type.configurable = false;
        descriptors.type.writable = false;
        Object.defineProperties(this, descriptors);
    }
}
export const klass = Transcript;
export default Transcript;
register(Type.Transcript, Transcript);    //# sourceMappingURL=Transcript.js.map
